module.exports = __webpack_public_path__ + "static/media/mastercard.0e666676.svg";